export const SEGMENTS_GET_SUCCESS = 'SEGMENTS_GET_SUCCESS'
export const SEGMENT_CREATE_SUCCESS = 'SEGMENT_CREATE_SUCCESS'
export const SEGMENT_DELETE_SUCCESS = 'SEGMENT_DELETE_SUCCESS'
